// CacheKey 856aba7de22a00dae64aded431abd4b3
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-UCSF_MEDICAL_CENTER": {
    data_view: {
      headers: {
        defaults: {
          patient: {
            other_insurance_indicator: "SFHP Flag"
          }
        }
      }
    }
  }
}

